import dashBoardService from '../../services/dashBoard.service'

export default {
    async getDataDashBoard({dispatch, commit}, data) {
        return await dashBoardService.getDataDashBoard(data)
            .then(response => {
                if (response.success && response.data) {
                    const dataDashBoard = response.data
                    commit("SET_DATA_DASHBOARD", dataDashBoard)
                    return Promise.resolve(response.data);
                } else {
                    commit("SET_DATA_DASHBOARD", [])
                    dispatch("alertError", response.message, { root: true });
                    return Promise.reject(response.message);
                }
            }).catch(error => {
                commit("SET_DATA_DASHBOARD", [])
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },

    async getListTypeDashBoard({dispatch, commit}) {
        return await dashBoardService.getListTypeDashBoard()
            .then(response => {
                if (response.success && response.data) {
                    const listTypeDashBoard = response.data
                    commit("SET_LIST_TYPE_DASHBOARD", listTypeDashBoard)
                    return Promise.resolve(response.data);
                } else {
                    commit("SET_LIST_TYPE_DASHBOARD", [])
                    dispatch("alertError", response.message, { root: true });
                    return Promise.reject(response.message);
                }
            }).catch(error => {
                commit("SET_LIST_TYPE_DASHBOARD", [])
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },

    async getListUserDashBoard({dispatch, commit}, data) {
        return await dashBoardService.getListUserDashBoard(data)
            .then(response => {
                if (response.success && response.data) {
                    const listUserDashBoard = response.data
                    commit("SET_LIST_USER_DASHBOARD", listUserDashBoard)
                    return Promise.resolve(response.data);
                } else {
                    commit("SET_LIST_USER_DASHBOARD", [])
                    dispatch("alertError", response.message, { root: true });
                    return Promise.reject(response.message);
                }
            }).catch(error => {
                commit("SET_LIST_USER_DASHBOARD", [])
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },
}